import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  handleChunkLoadError = () => {
    console.log("Coming to Chunk Refresh in Container ");
    if ("caches" in window) {
      caches?.keys().then(this.handleCacheClearing);
    } else {
      window.location.reload(true);
    }
  };

  handleCacheClearing = (names) => {
    console.log("Container caches clear for CHunk Error: ", { names });
    Promise.all(names?.map(this.deleteCache)).then(() => {
      console.log("All caches cleared.");
      window.location.reload(true);
    });
  };

  deleteCache = (name) => caches?.delete(name);

  componentDidCatch(error, errorInfo) {
    console.log("Error Boundary Caught Error Container");
    console.log(error);
    console.log(errorInfo);
    console.log("-----------------------------------------");
    // You can check the error message or type if it's a ChunkLoadError
    if (
      (error + "")?.includes("ChunkLoadError") ||
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("ChunkLoadError")
    ) {
      this.handleChunkLoadError();
    } else {
      console.error(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}
